import { makeStyles } from '@material-ui/core'

export const useHierarchyWiseItemsTableStyle = makeStyles(theme => ({
  hierarchyWiseTableActionContainer: {
    margin: '10px 0'
  }
}))

/* .hierarchy-wise-table-container .rv-sticky-parent-node {
  width: unset;
}
.hierarchy-wise-table-container .rv-sticky-parent-node .rv-sticky-node-list {
  width: unset;
}
.hierarchy-wise-table-container
  .rv-sticky-parent-node
  .rv-sticky-node-list
  .rv-sticky-leaf-node {
  width: unset;
} */
